import { Bell } from 'lucide-react';
import { useNotificationStore } from '@/stores/notification-store';
import { NotificationPanel } from './notification-panel';

export function NotificationBell() {
  const alertCount = useNotificationStore((s) => s.alertCount);
  const togglePanel = useNotificationStore((s) => s.togglePanel);

  return (
    <div className="relative" data-notification-bell>
      <button
        onClick={togglePanel}
        className="relative rounded-lg p-2 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
      >
        <Bell className="h-5 w-5" />
        {alertCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-destructive text-[10px] font-bold text-destructive-foreground">
            {alertCount > 9 ? '9+' : alertCount}
          </span>
        )}
      </button>
      <NotificationPanel />
    </div>
  );
}
